import { DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {
  RdsButtonComponent,
  RdsCellDefDirective,
  RdsCellDirective,
  RdsColumnDefDirective,
  RdsHeaderCellDefDirective,
  RdsHeaderCellDirective,
  RdsHeaderRowComponent,
  RdsHeaderRowDefDirective,
  RdsPaginatorComponent,
  RdsRowComponent,
  RdsRowDefDirective,
  RdsTableComponent,
  RdsTableDataSource,
} from '@rds/angular-components';
import { RdsPaginatorPageEvent } from '@rds/core';

import { TablePaginationState } from '../../../core/model/pagination.model';
import { BookingChartTableRowDTO } from '../../model/chart.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'bsh-bookings-table',
  templateUrl: './bookings-table.component.html',
  styleUrl: './bookings-table.component.scss',
  imports: [
    DatePipe,
    RdsButtonComponent,
    RdsTableComponent,
    RdsColumnDefDirective,
    RdsHeaderCellDirective,
    RdsHeaderCellDefDirective,
    RdsCellDefDirective,
    RdsCellDirective,
    RdsHeaderRowComponent,
    RdsHeaderRowDefDirective,
    RdsRowComponent,
    RdsRowDefDirective,
    RdsPaginatorComponent,
  ],
})
export class BookingsTableComponent {
  protected readonly displayedColumns: string[] = [
    'id',
    'eventName',
    'startTime',
    'endTime',
    'createTime',
    'numberOfPeople',
    'roomType',
    'roomName',
    'services',
    'status',
  ];
  protected readonly datasource =
    new RdsTableDataSource<BookingChartTableRowDTO>().init();
  protected readonly defaultPaginationState: Pick<
    TablePaginationState,
    'length' | 'pageIndex' | 'pageSize'
  > = {
    length: 0,
    pageIndex: 0,
    pageSize: 10,
  };

  @Input() paginationState: Pick<
    TablePaginationState,
    'length' | 'pageIndex' | 'pageSize'
  > = this.defaultPaginationState;
  @Output() pageChanged = new EventEmitter<RdsPaginatorPageEvent>();
  @Output() csvExportRequested = new EventEmitter<void>();

  @Input() set bookingsData(value: BookingChartTableRowDTO[] | null) {
    this.datasource.data = value ?? [];
  }

  exportToCSV() {
    this.csvExportRequested.emit();
  }

  protected onPageChange(event: RdsPaginatorPageEvent) {
    this.pageChanged.emit(event);
  }
}
